// @flow
import { type ReservationType } from 'types/v1/reservation'
import { getBillStatementPropsForChange } from 'components/molecules/BillStatement/presenter'
import { getReservationDatePropsForChange } from 'components/molecules/ReservationDate/presenter'

export function getReservationChangeRequestBlockProps(
  reservation: ReservationType,
  unapprovedReservation: ReservationType,
) {
  const reservedRoom = reservation.room || {}

  return {
    srcSpaceImage:
      reservedRoom.thumbnails &&
      reservedRoom.thumbnails[0] &&
      reservedRoom.thumbnails[0].image,
    textSpaceName: reservedRoom.name,
    ...getReservationDatePropsForChange(reservation, unapprovedReservation),
    billStatementProps: getBillStatementPropsForChange(
      reservation,
      unapprovedReservation,
    ),
  }
}



// WEBPACK FOOTER //
// ./src/components/molecules/ReservationChangeRequestBlock/presenter.js